import React from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import ExitIcon from '@material-ui/icons/PowerSettingsNew';
import classnames from 'classnames';
import { translate, userLogout as userLogoutAction } from 'ra-core';
import UserIcon from '../../assets/SVGicon';


const styles = theme => ({
    menuItem: {
        color: theme.palette.text.secondary,
    },
    iconMenuPaddingStyle: {
        paddingRight: '1.2em',
    },
    iconPaddingStyle: {
        paddingRight: theme.spacing.unit,
    },
});

const sanitizeRestProps = ({
    classes,
    className,
    translate,
    userLogout,
    locale,
    redirectTo,
    ...rest
}) => rest;

const go_user_profil = () => {
    //transitionTo('https://guides.emberjs.com/release/routing/redirection/')

}

/**
 * Logout button component, to be passed to the Admin component
 *
 * Used for the Logout Menu item in the sidebar
 */


 
const Logout = ({ classes, className, translate, userLogout, username, userId, userPhoto, emailPicture, photoURL, ...rest }) => (
    <div>
        <MenuItem
        className={classnames('logout', classes.menuItem, className)}
        onClick={go_user_profil}
        {...sanitizeRestProps(rest)}
    >
        <span className={classes.iconMenuPaddingStyle}>
            {/* <ExitIcon /> */}
            {   photoURL ? (
                <img
                src={photoURL}
                alt="Default"
                style={{
                    width: 25,
                    height: 25,
                    borderRadius: 40
                }}
                />
        
            ) : (
                UserIcon('28', { marginTop: 0 }, 'grey')
                )
            }
        </span>
        {/* {translate('ra.auth.logout')} */}
        {/* <a href={`https://apolhygie.x-squad.com/#/users/${userId}/show`} style={{color: 'green', textDecoration: 'none' }} >{username}</a> */}
        {/* <Link>lolo</Link>  */}
        <Link to={`/users/${userId}/show`}  style={{color: 'green', textDecoration: 'none' }} >{username} </Link>

    </MenuItem>
    <MenuItem
        className={classnames('logout', classes.menuItem, className)}
        onClick={userLogout}
        {...sanitizeRestProps(rest)}
    >
        <span className={classes.iconMenuPaddingStyle}>
            <ExitIcon />
        </span>
        {translate('ra.auth.logout')}
    </MenuItem>
    </div>
);

Logout.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    translate: PropTypes.func,
    userLogout: PropTypes.func,
    redirectTo: PropTypes.string,
};

const mapStateToProps = state => ({
    theme: state.theme,
});

const mapDispatchToProps = (dispatch, { redirectTo }) => ({
    userLogout: () => dispatch(userLogoutAction(redirectTo)),
});

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(styles)
);

export default enhance(Logout);


// WEBPACK FOOTER //
// ./src/components/login/MyLogoutButton.js